<template>
  <div class="field">
    <input
      :disabled="company === '' ||disabled"
      id="imagefile"
      class="field__input"
      label="Logo"
      name="image"
      ref="imagefile"
      type="file"
      accept="image/*"
      @change="uploadFile()"
    />
    <label for="image" class="field__label">Logo</label>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "LogoUpload",
  props: {
    company: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
    }
  },
  methods: {
    async uploadFile() {
      const files = this.$refs.imagefile.files
      const logo = files[0]

      var storageRef = firebase.storage().ref('logos/' + 'logo-'+this.company);
      const uploadFile = storageRef.put(logo);

      this.$emit("status-updated", {
        status: "uploading",
      });

      await uploadFile.on(
        "state_changed",
        snapshot => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
        },
        err => {
          console.log("Upload error ", err);
        },
        () => {
          uploadFile.snapshot.ref
            .getDownloadURL()
            .then(fileUrl => {
              this.$emit("status-updated", {
                status: "upload_complete",
                url: fileUrl
              });
            })
            .catch(err => {
              console.log("getDownloadURL error", err);
            });
        }
      );
    }
  }
}
</script>